/**
 * External dependencies
 */
import React from 'react';
import { Table } from 'antd';
import { Box, Stack, Text } from '@towersystems/towersystems-design-system';
import { map, get, size } from 'lodash';

/**
 * Internal dependencies
 */
import Tag from 'components/tag';

/**
 * Style dependencies
 */
import './styles.scss';

const Logs = ({ operation }) => {
    const columns = [
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'success',
            render: (a) => {
                if (true == a) {
                    return <Tag success>success</Tag>;
                }
                return <Tag error>failure</Tag>;
            },
        },
        {
            title: 'Resource Type',
            key: 'resource_type',
            dataIndex: 'resource_type',
            render: (a) => {
                return <Tag>{a}</Tag>;
            },
        },
        {
            title: 'ID',
            key: 'id',
            dataIndex: 'identifier',
        },
        {
            title: 'Errors',
            key: 'errors',
            dataIndex: 'errors',
            render: (a) => {
                return size(a) >= 1 ? size(a) : '-';
            },
        },
        {
            title: 'Warnings',
            key: 'warnings',
            dataIndex: 'warnings',
            render: (a) => {
                return size(a) >= 1 ? size(a) : '-';
            },
        },
    ];
    
    return (
        <Table
            columns={columns}
            dataSource={get(operation, 'result', [])}
            pagination={false}
            scroll={{ x: 'max-content' }}
            rowKey={k => get(k, 'success') + get(k, 'resource_type') + '_' + get(k, 'identifier')
}
            expandable={{
                expandedRowRender: (record) => {
                    return (
                        <Stack space='large'>
                            {map(get(record, 'errors'), ({ message, data }, k) => {
                                return (
                                    <Box key={k}>
                                        <Text>
                                            <Tag error marginRight='large'>
                                                error
                                            </Tag>
                                            {message} 
                                            {(data) && (
                                            <Text className="operation-details__logs--error">
                                                {data}
                                            </Text>
                                            )}
                                        </Text>
                                    </Box>
                                );
                            })}
                            {map(get(record, 'warnings'), ({ message, data }, k) => {
                                return (
                                    <Box key={k}>
                                        <Text>
                                            <Tag warning marginRight='large' className="operation-details__logs--warning">
                                                warning
                                            </Tag>
                                            {message}
                                            {(data) && (
                                            <Text className="operation-details__logs--error">
                                                {data}
                                            </Text>
                                            )}
                                        </Text>
                                    </Box>
                                );
                            })}
                        </Stack>
                    );
                },
                rowExpandable: (record) => size(record.warnings) >= 1 || size(record.errors) >= 1,
            }}
        />
    );
};

export default Logs;
